module.exports = __webpack_public_path__ + "img/domain.5194defa.svg";